<template>
  <div class="vlogin-card">
    <div class="vlogin-card__head">
      <h2 class="vlogin-card__title">Bienvenido de <em>vuelta</em></h2>
      <p class="vlogin-card__sub">{{ message }}</p>
    </div>

    <AuthForm
        ref="authForm"
        :options="options"
        @onSubmit="onSubmit"
        @onError="onError"
        @changeMode="changeMode" />

    <p class="vlogin-card__foot">Acceso exclusivo para el equipo de Vistar.</p>
  </div>
</template>

<script>
import AuthForm from "./AuthForm.vue";

export default {
  props: {
    options: {
      type: Object,
      default: () => ({ magicLink: { enabled: true }, password: { enabled: true } })
    }
  },
  components: { AuthForm },
  data: () => ({ message: 'Inicia sesión con tu correo y contraseña' }),
  methods: {
    resetErrors() { this.$refs.authForm.resetErrors() },
    onSubmit(response) { this.$emit('onSubmit', response) },
    onError(error) { this.$emit('onError', error) },
    changeMode(mode) { this.message = mode ? 'Inicia sesión con tu correo y contraseña' : 'Ingresa tu correo y recibe el enlace de acceso' }
  }
}
</script>
